import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { makeAutoObservable, runInAction } from 'mobx'
import { FeedbackStore } from 'store/generation/FeedbackStore'
import { MessageStore } from 'store/generation/MessageStore'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { ItemData } from 'type/Inference'

export class InferenceCarouselStore {
  readonly carousel: CarouselStore<InferenceStore>
  private _feedback: FeedbackStore | undefined
  private _message: MessageStore | undefined
  private _actions = false
  private _share = false
  private _looky = false
  private _extend: ItemData | undefined

  constructor(inference: InferenceStore | undefined, inferences: InferenceStore[]) {
    makeAutoObservable(this)
    this.carousel = new CarouselStore(inferences, { gap: opt.stand2 ? 48 : 24, angle: 4 })
    this.carousel.item = inference
  }

  get feedback(): FeedbackStore | undefined {
    return this._feedback
  }

  set feedback(value: FeedbackStore | undefined) {
    this._feedback = value
  }

  get message(): MessageStore | undefined {
    return this._message
  }

  set message(value: MessageStore | undefined) {
    this._message = value
  }

  get actions(): boolean {
    return this._actions
  }

  set actions(value: boolean) {
    this._actions = value
  }

  get share(): boolean {
    return this._share
  }

  set share(value: boolean) {
    this._share = value
  }

  get looky(): boolean {
    return this._looky
  }

  set looky(value: boolean) {
    this._looky = value
  }

  get extend(): ItemData | undefined {
    return this._extend
  }

  set extend(value: ItemData | undefined) {
    this._extend = value
  }

  showMessage(text: string) {
    const store = new MessageStore(text)
    this._message = store
    setTimeout(() => {
      if (this._message?.key === store.key) {
        runInAction(() => this._message = undefined)
      }
    }, 3000)
  }

  deleteInference(inference: InferenceStore) {
    this.carousel.deleteItem(inference)
  }
}
